import { PasswordAction } from '../../actions/resources/Password';
import * as Constants from '../../constants/resources';
import initialState from '../../InitialState';
import { State } from '../../types/resources/State';

const password = (
  state: State = initialState,
  action: PasswordAction
): State => {
  switch (action.type) {
    case Constants.PASSWORDS:
      return {
        ...state,
        password: {
          ...state.password,
          passwordsLoading: true
        }
      };
    case Constants.PASSWORDS_SUCCESS:
      return {
        ...state,
        password: {
          ...state.password,
          passwordsLoading: false,
          passwords: {
            passwords: action.payload.passwords.passwords,
            total: action.payload.passwords.total
          }
        }
      };
    case Constants.PASSWORDS_FAILED:
      return {
        ...state,
        password: {
          ...state.password,

          passwords: {
            passwords: [],
            total: 0
          },
          passwordsLoading: false
        }
      };
    case Constants.PASSWORD_DETAIL:
      return {
        ...state,
        password: {
          ...state.password,
          selectedPassword: {
            ...state.password.selectedPassword,
            selectedPasswordLoading: true
          }
        }
      };
    case Constants.PASSWORD_DETAIL_SUCCESS:
      return {
        ...state,
        password: {
          ...state.password,
          selectedPassword: {
            ...state.password.selectedPassword,
            detail: action.payload.passwordDetail,
            selectedPasswordLoading: false
          }
        }
      };
    case Constants.PASSWORD_DETAIL_FAILED:
      return {
        ...state,
        password: {
          ...state.password,
          selectedPassword: {
            ...state.password.selectedPassword,
            selectedPasswordLoading: false
          }
        }
      };
    default:
      return state;
  }
};

export default password;
